import { render, staticRenderFns } from "./OptContentColumn.vue?vue&type=template&id=956f8f44&scoped=true&"
import script from "./OptContentColumn.vue?vue&type=script&lang=js&"
export * from "./OptContentColumn.vue?vue&type=script&lang=js&"
import style0 from "./OptContentColumn.vue?vue&type=style&index=0&id=956f8f44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956f8f44",
  null
  
)

export default component.exports